// extracted by mini-css-extract-plugin
export default {"root":"IbB_3Wpz"};